import React from 'react';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import fr from 'facet-rest';
import { BaseWizardStepOverride } from 'Views/Page/Content/Templates/BaseWizardStepOverride';
import PropTypes from 'prop-types';
import Content from './Content';

export default function CashAccountProposal({ resource }) {
  return (
    <WizardStepWrapperTemplate
      layout={Content}
      metaOverrideSet={BaseWizardStepOverride}
      resource={resource}
    />
  );
}
CashAccountProposal.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
